import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      title={theme === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
      aria-label="Toggle Dashboard Theme"
      className="p-2 rounded-xl transition-all duration-200 cursor-pointer flex items-center justify-center 
                 bg-slate-100 text-slate-700 hover:bg-slate-200 border border-slate-200
                 dark:bg-slate-800/80 dark:text-amber-400 dark:hover:bg-slate-700/80 dark:border-slate-700/80 shadow-sm"
    >
      {theme === 'dark' ? (
        <Sun className="w-4 h-4 transition-transform duration-300 hover:rotate-90 text-amber-400" />
      ) : (
        <Moon className="w-4 h-4 transition-transform duration-300 hover:-rotate-12 text-slate-700" />
      )}
    </button>
  );
};

export default ThemeToggle;
